import { FC } from 'react';
import { InvestmentBlock, MediaData } from './InvestmentBlock';

const media: MediaData = [
  {
    id: 1,
    investorShortStory: '«Заработала на инвестициях больше 5 млн рублей»',
    investorInfo: 'Серафима, дизайнер интерьеров, инвестор',
    investorStory: 'В 29 лет взяла первую ипотеку, а сейчас получает пассивный доход с двух собственных квартир.',
    video: {
      poster: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/investors/Serafima.jpg',
      sources: [
        {
          src: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/videos/pik/investors/pik_serafima_long.mp4',
          type: 'video/mp4',
        },
      ],
    },
  },
  {
    id: 2,
    investorShortStory: '«Доход 35% за полтора года»',
    investorInfo: 'Андрей, бизнесмен, инвестор',
    investorStory: 'Раньше инвестировал в коммерческую недвижимость, но заметил, что жилая быстрее приносит доход.',
    video: {
      poster: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/investors/Andrey.jpg',
      sources: [
        {
          src: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/videos/pik/investors/pik_andrey_long.mp4',
          type: 'video/mp4',
        },
      ],
    },
  },
  {
    id: 3,
    investorShortStory: '«Увеличил свой капитал в 5 раз, инвестируя в квартиры ПИК»',
    investorInfo: 'Михаил, преподаватель, инвестор',
    investorStory: 'Начал с квартиры в Подмосковье, а спустя 2 года купил уже шестую квартиру от ПИК.',
    video: {
      poster: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/investors/Michail.jpg',
      sources: [
        {
          src: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/videos/pik/investors/pik_misha_long.mp4',
          type: 'video/mp4',
        },
      ],
    },
  },
];

export const InvestmentBlockContainer: FC = () => {
  return (
    <InvestmentBlock
      title="Квартиры с видом на доход"
      media={media}
      id="investment"
      description="Недвижимость всегда считалась надёжным вложением. Но как покупать квартиры, чтобы не только сохранить сбережения, а ещё и преумножить их в перспективе? На примере квартир ПИК мы изучили разные способы инвестирования и предлагаем несколько сценариев, актуальных в 2025 году"
    />
  );
};
